export default class MegaMenu {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {
        this.$view.find('.navigation-wrapper > ul > li > a').on('click', function(e) {
            e.preventDefault();
            $(".lazlod-megamenu").each(function() {
                $(this).attr("src",$(this).data("src"));
            });
            $('.megamenu-wrapper').removeClass('showNav');
            $(this).siblings('.megamenu-wrapper').addClass('showNav');
        });

        this.$view.find('.close-megamenu').on('click', function() {
            $('.megamenu-wrapper').removeClass('showNav');
        });
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/MegaMenu.js